import { useInfiniteQueryMemberInvoiceListNewAsMember } from "@gymflow/api";
import { useTranslation } from "react-i18next";

import useGymflowModels from "../../../../store";
import { InfiniteScrollContainer, Spinner } from "../../../atoms";
import { HostedPagesProfileCard } from "../../components/HostedPagesProfileCard";
import { HostedPagesReceiptCard } from "./HostesPagesReceiptCard";

export type HostedPagesProfileReceiptsListProps = {};
export const HostedPagesProfileReceiptsList =
  ({}: HostedPagesProfileReceiptsListProps) => {
    const { t } = useTranslation();
    const { api } = useGymflowModels();

    const queryInvoiceList = useInfiniteQueryMemberInvoiceListNewAsMember({
      api,
      params: {
        limit: 15,
      },
    });

    const { data: dataInvoiceList, isLoading: isLoadingInvoiceList } =
      queryInvoiceList;
    const listOfUsage = dataInvoiceList?.pages.flatMap((e) => e.content) || [];

    return (
      <HostedPagesProfileCard.Container className="relative flex h-full max-h-full flex-1 flex-col gap-3 overflow-hidden">
        <div className="absolute inset-0 flex flex-col gap-3.5 overflow-y-auto overflow-x-hidden">
          <div className="dark:text-gray-25 ml-4 mt-4 text-lg font-semibold text-gray-950">
            {t("page.hostedPagesProfileReceipts.receipts")}
          </div>
          {isLoadingInvoiceList ? (
            <Spinner className="size-7" />
          ) : (
            <InfiniteScrollContainer
              className="flex flex-1 flex-col gap-2 overflow-y-auto p-4 pt-0"
              direction="vertical"
              query={queryInvoiceList}
            >
              {listOfUsage.map((item) => (
                <HostedPagesReceiptCard key={item.id} invoice={item} />
              ))}
            </InfiniteScrollContainer>
          )}
        </div>
      </HostedPagesProfileCard.Container>
    );
  };
